import { string as yupString, number as yupNumber } from 'yup';
import { translate } from '../../locales/i18n';
import validation from '../../data/validation.json';

export const {
  WAYPOINT_NAME_MIN_LEN,
} = validation;

const nameValidation = yupString()
  .min(WAYPOINT_NAME_MIN_LEN, (opts) => translate('validation_endpoint_name_short', opts))
  // FIXME(clairbee): starts uppercase
  // FIXME(clairbee): not all caps
  .required(translate('validation_endpoint_name_required'));

const extraStayValidation = yupNumber()
  .integer(translate('validation_endpoint_extra_stay_number'))
  .moreThan(-1, translate('validation_endpoint_extra_stay_number'));
// .required(() => translate('validation_endpoint_extra_stay_required'));

const imageCommentValidation = yupString()
  .min(16, (opts) => translate('validation_image_name_short', opts))
  // FIXME(clairbee): starts uppercase
  // FIXME(clairbee): not all caps
  .required(translate('validation_image_name_required'));

const imageDelayValidation = yupNumber()
  .integer(translate('validation_image_delay_number'))
  .moreThan(-1, translate('validation_image_delay_number'));
// .required(() => translate('validation_image_delay_number'));

export {
  nameValidation,
  extraStayValidation,
  imageCommentValidation,
  imageDelayValidation,
};
